import type { UserAddressFieldType, UserAddressKind, UserAddressTag } from '../entities'

export const BUILDING_DETAILS_T_KEYS: Record<UserAddressFieldType, string> = {
  STREET_NAME: '',
  STREET_NUMBER: '',
  POSTAL_CODE: '',
  BUILDING_NAME: 'address-details.building-details.building-name',
  STAIRCASE: '',
  FLOOR_NUMBER: 'address-details.building-details.floor',
  DOOR_NUMBER: 'address-details.building-details.door',
  DISTRICT: '',
  INTERSECTION: '',
  ADDITIONAL_INFORMATION: 'address-details.building-details.courier-instructions',
  PROVINCE: '',
}

export const pinIconPaths = {
  pinIcon: 'dh:customer-assets-glovo/address_flow/address_book/pin.svg',
  pinMoving: 'dh:customer-assets-glovo/address_flow/address_book/pin_dragging.svg',
  pinOutOfZone: 'dh:customer-assets-glovo/address_flow/address_book/pin_out.svg',
  pinRefineEntrance: 'dh:customer-assets-glovo/address_flow/address_book/pin_refine_entrance.svg',
}

export const ADDRESS_TYPE_ZOOM_LEVEL = 18

export const SET_ENTRANCE_ZOOM_LEVEL = 18
interface BuildingDetailsFieldOption {
  type: UserAddressFieldType
  required: boolean
}

export const BUILDING_DETAILS_FIELD_ORDER: Record<UserAddressKind, UserAddressFieldType[]> = {
  HOUSE: ['FLOOR_NUMBER', 'DOOR_NUMBER', 'ADDITIONAL_INFORMATION'],
  APARTMENT: ['FLOOR_NUMBER', 'DOOR_NUMBER', 'BUILDING_NAME', 'ADDITIONAL_INFORMATION'],
  OFFICE: ['FLOOR_NUMBER', 'DOOR_NUMBER', 'BUILDING_NAME', 'ADDITIONAL_INFORMATION'],
  OTHER: ['ADDITIONAL_INFORMATION'],
}

export const BUILDING_DETAILS_FIELD_OPTIONS: Record<UserAddressKind, BuildingDetailsFieldOption[]> =
  {
    HOUSE: [
      {
        type: 'FLOOR_NUMBER',
        required: false,
      },
      {
        type: 'DOOR_NUMBER',
        required: false,
      },
      {
        type: 'ADDITIONAL_INFORMATION',
        required: false,
      },
    ],
    APARTMENT: [
      {
        type: 'FLOOR_NUMBER',
        required: true,
      },
      {
        type: 'DOOR_NUMBER',
        required: true,
      },
      {
        type: 'BUILDING_NAME',
        required: false,
      },
      {
        type: 'ADDITIONAL_INFORMATION',
        required: false,
      },
    ],
    OFFICE: [
      {
        type: 'FLOOR_NUMBER',
        required: false,
      },
      {
        type: 'DOOR_NUMBER',
        required: false,
      },
      {
        type: 'BUILDING_NAME',
        required: true,
      },
      {
        type: 'ADDITIONAL_INFORMATION',
        required: false,
      },
    ],
    OTHER: [
      {
        type: 'ADDITIONAL_INFORMATION',
        required: false,
      },
    ],
  }

export const ADDRESS_TAG_T_KEYS: Record<UserAddressTag, string> = {
  HOME: 'address-details.save-address-as.home',
  WORK: 'address-details.save-address-as.work',
  FLAT: 'address-details.save-address-as.flat',
  HOSPITAL: 'address-details.save-address-as.hospital',
  OFFICE: 'address-details.save-address-as.office',
  SCHOOL: 'address-details.save-address-as.school',
}

export const ADDRESS_TAG_OPTIONS: Record<UserAddressKind, UserAddressTag[]> = {
  HOUSE: ['HOME', 'FLAT'],
  APARTMENT: ['HOME', 'FLAT'],
  OFFICE: ['OFFICE', 'WORK'],
  OTHER: ['HOSPITAL', 'SCHOOL'],
}
